<template>
  <!-- {{ isQuoteField + '' }} -->
  <jw-input v-if="isQuoteField" v-model="modulesItem.fieldValue" disabled placeholder="-" class="system-form-item-fields ly-form-item-fields-disabled" />
  <fh-person v-else :className="['system-form-item-fields', isFocus ? 'is-focus' : '']" position="bl" :maxTagCount="from == 35 ? 1 : 2" :item="modulesItem.setting?.fv" :disabled="disabled" @popup-visible-change="handlePopupVisibleChange" :multiple="multiple" @cb="setModulesItem" @remove="handleRemove"> </fh-person>
</template>

<script setup>
import { ref, computed, inject } from 'vue';
const emits = defineEmits(['cb', 'selectPopVisibleCb']);
import { tools } from '@/utils/tools';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  formDisabled: {
    type: Boolean,
    default: false
  },
  from: {
    type: Number || String,
    default: () => 20
  }
});
const isFocus = ref(false);

const modulesItem = ref(props?.modules);

const disabled = computed(() => {
  return isQuoteField.value || props.formDisabled || props.disabledAll || props.modules.businessData == '0';
});
const multiple = computed(() => {
  return tools.isJSON(modulesItem?.value?.setting?.fieldExt) ? (JSON.parse(modulesItem?.value?.setting?.fieldExt)?.single == 1 ? false : true) : true;
});
const handlePopupVisibleChange = (visible) => {
  isFocus.value = visible;
  //校验必填/显示
  if (!visible) {
    emits('selectPopVisibleCb', modulesItem.value);
  }
};

const setModulesItem = (v, mp) => {
  emits('personDepartCb', v, mp); //人员和部门
};

const handleRemove = (v) => {
  setModulesItem(v); //更新数据
  emits('selectPopVisibleCb', modulesItem.value); //触发校验/保存
};
</script>
